<template>
  <div>
    <h2>住所一覧をアップロード</h2>
    <div>住所のデータは <code>都道府県</code> <code>市町村</code> <code>住所</code> <code>緯度</code> <code>経度</code>
      の5つのカラムを含んだCSVファイルです。<br/>
      最初の行はヘッダーと <code>都道府県</code> <code>市町村</code> <code>住所</code> <code>緯度</code> <code>経度</code>
      のカラムを含んでいる必要があります。<br/>
      これら以外のカラムは無視されます。<br/>
      <code>緯度</code> <code>経度</code> が空の行は無視されます。<br/>
      CSVファイルの文字コードは UTF-8 である必要があります。<br/>
      すべてのデータは、アップロードされたデータで上書きされます。
    </div>
    <v-btn raised color="primary" @click="$refs.uploadFile.click()">ファイルを選択</v-btn>
    <input type="file" ref="uploadFile" style="display:none" @change="uploadCsv"/>

    <v-dialog width="500" v-model="showUploadResult">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          <span v-if="uploadResultSuccess">アップロードしました</span>
          <span v-if="!uploadResultSuccess">エラーが発生しました</span>
        </v-card-title>
        <v-card-text v-text="uploadResultMessage">てすと</v-card-text>
        <v-card-text v-if="uploadResultIgnored.length > 0" v-text="uploadResultIgnored"
                     style="white-space: pre-wrap; margin-top:1em; color:darkorange"></v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="showUploadResult=false">閉じる</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- アップロード中のプログレスバー -->
    <LoadingOverlay v-if="progress"/>
  </div>
</template>

<script>
import {getAuthToken, sessionTimeouted} from '@/lib/common'
import {postAddresses} from '@/lib/api'
import LoadingOverlay from '@/components/LoadingOverlay'

export default {
  name: 'Admin',
  components: {LoadingOverlay},
  data: function () {
    return {
      progress: false,
      uploadResultSuccess: false,
      uploadResultMessage: '',
      uploadResultIgnored: '',
      showUploadResult: false
    }
  },
  methods: {
    // ファイルをアップロード
    uploadCsv: function (e) {
      if (e.target.files.length > 0) {
        const file = e.target.files[0]
        console.log(`uploadCsv ${file}`)
        this.progress = true
        this.uploadResultMessage = null
        postAddresses(getAuthToken(), file)
          .then((response) => {
            this.progress = false
            let message = `登録済みの住所は ${response.data.count} 件です。`
            if (response.data.warnings) {
              this.uploadResultIgnored = response.data.warnings
            }
            this.showMessage(message)
          })
          .catch((error) => {
            console.log(`アップロードエラー ${error}`)
            this.progress = false
            if (error.response) {
              let message = error.response.data.message || error.message
              if (error.response.data.line) {
                message += error.response.data.line
              }
              this.showError(message)
            } else if (error.request) {
              this.showError(error.request)
            } else {
              this.showError(error.message)
            }
            if (error.response.status === 401) {
              sessionTimeouted(this)
            }
          })
      }
    },
    showMessage: function (message) {
      this.uploadResultSuccess = true
      this.uploadResultMessage = message
      this.showUploadResult = true
    },
    showError: function (message) {
      this.uploadResultSuccess = false
      this.uploadResultMessage = message
      this.uploadResultIgnored = ''
      this.showUploadResult = true
    }
  }
}
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/UploadAddresses.vue